<template>

    <div>

        <div class="home-page-card card-wrap">

            <img class="card-img" :src=" homepageImg "  @error="$event.target.src = '../../img/logo.jpg'" />

            <div class="inner-wrap">

                <h3>Skip the line</h3>
                <p :style="{ height: '55px' }">There is no need to wait anymore, pick up your order as soon as you arrive</p>
            </div>
        </div>

        <div class="home-page-card card-wrap" v-if=" environment != 'Production' ">

            <div class="inner-wrap" style="padding-top: 25px">

                <h5 style="margin: 0;"> Environment: {{ environment }} </h5>
                <p style="margin: 5px 0px 0px; color: #777">*this does not appear on production</p>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'user-dashboard',
        computed: {

            ...mapGetters({

                isAuth                  : 'auth/isAuth',
                merchantSlug            : 'merchant/merchantSlug',
                allMerchantsWithImages  : 'merchant/allMerchantsWithImages',
                imageUrl                : 'imageUrl',
            }),
            environment(){

                return process.env.VUE_APP_ENVIRONMENT
            },
            homepageImg(){
                
                if (this.environment == 'local') {
                    return '../../../img/logo.jpg'
                } else {
                    if (this.merchantSlug == null) {
                        return '../../../img/logo.jpg'
                    } else {

                        var urlImagesFromStaticRealPayment = '';
                        const merchantsLogos = this.allMerchantsWithImages;
                        merchantsLogos.forEach( merchantLogo => {
                            if (merchantLogo.slug == this.merchantSlug) {
                                
                                urlImagesFromStaticRealPayment = merchantLogo.imagePath + merchantLogo.imageName;
                            }     
                        });
                        return this.imageUrl + urlImagesFromStaticRealPayment
                    }
                }
            },
        },
        methods: {

            redirect(){

                this.$router.push({

                    name: this.isAuth ? 'order-menu' : 'signin',
                    params : { slug : this.merchantSlug }
                });
            }
        },

        created(){

            console.log( 'getting all merchants with images...' );
            this.$store.dispatch( 'merchant/getQuickOrderMerchants' );
        }
    }
</script>

<style scoped>

    .home-page-card {

        padding: 0px;
        max-width: 300px;
        margin: 0px auto 30px;
        border-radius: 10px !important;
    }
    .card-img {

        width: 100%;
        max-height: 400px;
        min-height: 200px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    .inner-wrap {

        padding-left: 10px;
        padding-bottom: 20px;
    }
    button {

        margin: 20px 0px;
        height: 35px;
        border-radius: 15px;
    }
</style>